<i18n src="@/locales/views/agro_exporter/production/uniq_final_packing_list/base.yml" lang="yaml"></i18n>
<template>
  <div class="mt-8 mb-8">
    <h1 class="page-title" v-if="agro_exporter_process">
      {{ $t("labels.module_name") }}<span class="space-icon"></span
      ><i class="fa-solid fa-chevron-right fa-xs"></i
      ><span class="space-icon"></span>{{ agro_exporter_process.name }}
    </h1>
  </div>
</template>

<script>
import BasicContainerExportQRequester from "@/views/agro_exporter/requesters/production/basic_container_export/query.js";

export default {
  name: "AEProductionBasicContainerExportAgroExporterProcessHeader",
  components: {},
  props: ["agro_exporter_process_id"],
  data() {
    return {
      agro_exporter_process: null,
    };
  },
  methods: {
    fetchAgroExporterProcess: async function () {
      let response =
        await BasicContainerExportQRequester.fetchAgroExporterProcess(
          this.agro_exporter_process_id
        );
      this.agro_exporter_process = response.data;
    },
  },
  created() {
    this.checkIfAuthenticated();
    this.fetchAgroExporterProcess();
  },
};
</script>

